import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ReactDOM from "react-dom";

import NewScopeCategoryInterface from './newScopeCategoryInterface';
import {store} from "../../main";
import {messageBox_Show} from "../../actions/A_Popups";
import * as actionTypes from "../../constants/actionTypes";

// const WAIT_INTERVAL = 2000;
const ENTER_KEY = 13;

class NewScopeCategoryInput extends Component {

  static propTypes = {
    qtCategory: NewScopeCategoryInterface.isRequired,
    onChange: PropTypes.func.isRequired
  };

  state = {
    value: ''
  };

  // timer = null;

  componentDidMount() {
    if (this.props.value) {
      this.setState({
        value: this.props.value
      })
    }
  }

  handleChange = e => {
    // clearTimeout(this.timer);
    this.setState({ value: e.target.value });
    // this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL)
  };

  handleKeyDown = e => {
    if (e.keyCode === ENTER_KEY) {
      clearTimeout(this.timer);
      this.triggerChange()
    }
  };

  triggerChange = (event) => {
    if (!this.state.value) {
      const excludedClassNames = ["message-system-dismiss-button-wrapper", "message-box-buttons"];
      if (!(excludedClassNames.some(className => {
        return event.target.classList.contains(className) || event.target.closest("."+className)
      }))) {
        store.dispatch({
          type: actionTypes.POPUP_MESSAGE_BOX_SHOW,
          payload: {
            visible: true,
            title: 'Error',
            message: 'Category name can not be empty',
            type: 'error',
            uibuttons: [{
              class: "red",
              text: 'Ok',
              onClick: () => {
                store.dispatch(messageBox_Show(false));
                ReactDOM.findDOMNode(this.refs.inputElement).focus();
              }
            }]
          }
        });
      }
      return false
    } else if (this.props.qtCategories.some(qtCat => qtCat.name.trim() === this.state.value.trim())) {
      console.log(this.props);
      store.dispatch({
        type: actionTypes.POPUP_MESSAGE_BOX_SHOW,
        payload: {
          visible: true,
          title: 'Error',
          message: 'Duplicate category name can is not allowed',
          type: 'error',
          uibuttons: [{
            class: "red",
            text: 'Ok',
            onClick: () => {
              store.dispatch(messageBox_Show(false));
              ReactDOM.findDOMNode(this.refs.inputElement).focus();
            }
          }]
        }
      });
      return false
    }
    this.props.onChange(this.state.value)
  };

  render() {
    const { ...rest } = this.props;

    return (
      <input
        ref="inputElement"
        type="text"
        className={rest.className}
        placeholder={rest.placeholder}
        value={this.state.value}
        onChange={this.handleChange}
        onKeyDown={this.handleKeyDown}
        onBlur={this.triggerChange}
        maxLength="35"
      />
    )
  }
}

const mapStateToProps = (store) => {
  return {
    qtCategories: store.newScope.qtCategories
  };
};

export default connect(mapStateToProps, {
})(NewScopeCategoryInput);
